import { useLocation } from 'react-router-dom';
export function useReferrer() {
    var _a;
    const location = useLocation();
    return { referrerUrl: ((_a = location.state) === null || _a === void 0 ? void 0 : _a.previousLocationPathname) || undefined };
}
// How to use:
// When we use navigate adjust the location state to include the previous location pathname
// navigate('path', {state: {previousLocationPathname: location.pathname}})
